/**
 * Texte brut pour l'édition admin des templates email.
 */

export function htmlToPlainText(html) {
  if (!html) return '';
  return html
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<[^>]+>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

export function plainTextToEmailHtml(text) {
  const raw = String(text || '').trim();
  if (!raw) return '';

  const escaped = raw
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  const paragraphs = escaped
    .split(/\n{2,}/)
    .map((block) => {
      const lines = block.split('\n').map((line) => (line.trim() ? line : '&nbsp;'));
      return `<p style="margin:0 0 14px;line-height:1.6;">${lines.join('<br>')}</p>`;
    })
    .join('');

  return `<!DOCTYPE html>
<html>
<head><meta charset="UTF-8"></head>
<body style="font-family:Arial,Helvetica,sans-serif;line-height:1.6;color:#333333;max-width:600px;margin:0 auto;padding:24px;">
${paragraphs}
</body>
</html>`;
}

export function getEditableBodyText(template) {
  if (!template) return '';
  if (template.bodyText && String(template.bodyText).trim()) {
    return String(template.bodyText).trim();
  }
  return htmlToPlainText(template.bodyHtml || '');
}

export function extractTemplateVariables(...texts) {
  const variableRegex = /\{([^}]+)\}/g;
  const matches = new Set();
  texts.forEach((text) => {
    if (!text) return;
    let match;
    const source = String(text);
    while ((match = variableRegex.exec(source)) !== null) {
      matches.add(match[0]);
    }
  });
  return [...matches];
}

export function prepareTemplatePayload(form) {
  const bodyText = String(form.bodyText ?? '').trim();
  const bodyHtml = plainTextToEmailHtml(bodyText);
  const variables = extractTemplateVariables(form.subject, bodyText);

  return {
    name: form.name,
    subject: form.subject,
    category: form.category,
    description: form.description,
    isActive: form.isActive,
    bodyText,
    bodyHtml,
    variables: variables.length > 0 ? variables : form.variables || [],
  };
}

export function applyVariablesToPlainText(plainText, variableMap) {
  let text = String(plainText || '');
  Object.entries(variableMap).forEach(([key, value]) => {
    const regex = new RegExp(key.replace(/[{}]/g, '\\$&'), 'g');
    text = text.replace(regex, String(value ?? ''));
  });
  return text;
}

export const PREVIEW_VARIABLE_SAMPLES = {
  '{userName}': 'Jean Dupont',
  '{firstName}': 'Jean',
  '{prenom}': 'Jean',
  '{lastName}': 'Dupont',
  '{nom}': 'Dupont',
  '{loginUrl}': 'https://liberty.com/login',
  '{resetLink}': 'https://liberty.com/reset-password?token=xxx123',
  '{expirationTime}': '24 heures',
  '{quoteId}': 'Q-12345',
  '{amount}': '150,00 TND',
  '{clientName}': 'Marie Martin',
  '{transactionId}': 'TXN-67890',
  '{paymentDate}': new Date().toLocaleDateString('fr-FR'),
  '{userEmail}': 'test@example.com',
  '{companyName}': 'Liberty',
  '{orderNumber}': 'ORD-12345',
};

export function buildPreviewHtml(bodyText, extraVariables = {}) {
  const filled = applyVariablesToPlainText(bodyText, {
    ...PREVIEW_VARIABLE_SAMPLES,
    ...extraVariables,
  });
  return plainTextToEmailHtml(filled);
}
